import { request } from "@weapp/utils";
import { getTokenStorage, encryptRsa, passportHost } from "../../utils";
import { publicUrlapi } from "../../constants";

// 根据租户Key检测账号绑定状态
export const checkLogin = () => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/join/checkLogin`,
    method: "GET"
  });
};


// 绑定已有账号
export const bindExistAccount = (params: any) => {
  //暂时注释
  params = encryptRsa(params, 'password');
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/authBind/authBind`,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
    method: "POST",
    data: params
  });
};
// 创建随机人员账号
export const createRandomAccount = (params: any) => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/authBind/authSkipBind`,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
    method: "POST",
    data: params
  });
};
